// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"29c8b941","453":"37e97140"}[chunkId] + ".chunk.js";
};